export default function DestinationShowcase() {
  const destinations = [
    {
      name: '京都哲学之道',
      location: '日本 · 京都',
      image: 'https://readdy.ai/api/search-image?query=Kyoto%20Philosophers%20Path%20in%20spring%2C%20cherry%20blossom%20tunnel%20along%20small%20canal%2C%20soft%20pink%20petals%20falling%2C%20stone%20path%20lined%20with%20trees%2C%20traditional%20Japanese%20houses%20nearby%2C%20warm%20afternoon%20light%2C%20peaceful%20atmosphere&width=600&height=400&seq=dest-kyoto-01&orientation=landscape',
    },
    {
      name: '会安古城',
      location: '越南 · 广南',
      image: 'https://readdy.ai/api/search-image?query=Hoi%20An%20ancient%20town%20at%20dusk%2C%20colorful%20silk%20lanterns%20lighting%20up%2C%20yellow%20colonial%20buildings%2C%20Thu%20Bon%20River%20reflecting%20lantern%20lights%2C%20wooden%20boats%2C%20romantic%20spring%20evening%2C%20UNESCO%20heritage&width=600&height=400&seq=dest-hoian-01&orientation=landscape',
    },
    {
      name: '博卡拉费瓦湖',
      location: '尼泊尔 · 甘达基',
      image: 'https://readdy.ai/api/search-image?query=Phewa%20Lake%20Pokhara%20at%20sunrise%2C%20Machhapuchhre%20Fishtail%20mountain%20reflected%20in%20calm%20water%2C%20colorful%20wooden%20boats%2C%20hillsides%20with%20rhododendron%20blooms%2C%20spring%20morning%20mist%2C%20Himalayan%20serenity&width=600&height=400&seq=dest-pokhara-01&orientation=landscape',
    },
    {
      name: '济州岛油菜花田',
      location: '韩国 · 济州',
      image: 'https://readdy.ai/api/search-image?query=Jeju%20Island%20canola%20flower%20fields%20in%20full%20bloom%2C%20bright%20yellow%20flower%20carpet%20stretching%20to%20horizon%2C%20traditional%20stone%20walls%2C%20blue%20ocean%20in%20background%2C%20spring%20sunshine%2C%20vibrant%20cheerful%20scene&width=600&height=400&seq=dest-jeju-01&orientation=landscape',
    },
    {
      name: '大吉岭茶园',
      location: '印度 · 西孟加拉邦',
      image: 'https://readdy.ai/api/search-image?query=Darjeeling%20Happy%20Valley%20tea%20estate%20in%20spring%2C%20women%20picking%20tea%20in%20colorful%20saris%2C%20lush%20green%20terraced%20hills%2C%20Kanchenjunga%20mountain%20in%20background%2C%20morning%20sunlight%2C%20colonial%20tea%20factory%20building&width=600&height=400&seq=dest-darjeeling-01&orientation=landscape',
    },
    {
      name: '清迈素贴山',
      location: '泰国 · 清迈',
      image: 'https://readdy.ai/api/search-image?query=Wat%20Phra%20That%20Doi%20Suthep%20temple%20Chiang%20Mai%2C%20golden%20stupa%20shining%20in%20sunlight%2C%20staircase%20with%20naga%20serpent%20balustrades%2C%20tropical%20flowers%20surrounding%20temple%2C%20mountain%20panoramic%20view%2C%20spiritual%20spring%20morning&width=600&height=400&seq=dest-chiangmai-01&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs text-foreground-500 tracking-widest uppercase mb-2">精选景点</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            不可错过的春日目的地
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            每一个目的地都经过精心挑选，确保您能体验到最地道的亚洲春日风情
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {destinations.map((dest) => (
            <div
              key={dest.name}
              className="group relative rounded-lg overflow-hidden h-64 cursor-pointer"
            >
              <img
                src={dest.image}
                alt={dest.name}
                title={`${dest.name} - 亚洲春季旅游目的地`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-semibold text-base">{dest.name}</h3>
                <p className="text-white/70 text-xs mt-1">{dest.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}